import { useState, useEffect } from 'react';

export const useVehicleMakes = () => {
  const [makes, setMakes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Lista de fallback con marcas populares
  const fallbackMakes = [
    { Make_ID: 1, Make_Name: 'TOYOTA' },
    { Make_ID: 2, Make_Name: 'HONDA' },
    { Make_ID: 3, Make_Name: 'FORD' },
    { Make_ID: 4, Make_Name: 'CHEVROLET' },
    { Make_ID: 5, Make_Name: 'NISSAN' },
    { Make_ID: 6, Make_Name: 'BMW' },
    { Make_ID: 7, Make_Name: 'MERCEDES-BENZ' },
    { Make_ID: 8, Make_Name: 'AUDI' },
    { Make_ID: 9, Make_Name: 'VOLKSWAGEN' },
    { Make_ID: 10, Make_Name: 'HYUNDAI' },
    { Make_ID: 11, Make_Name: 'KIA' },
    { Make_ID: 12, Make_Name: 'MAZDA' },
    { Make_ID: 13, Make_Name: 'SUBARU' },
    { Make_ID: 14, Make_Name: 'LEXUS' },
    { Make_ID: 15, Make_Name: 'TESLA' }
  ];

  const fetchMakes = async () => {
    setLoading(true);
    setError(null);
    
    try {
      console.log('🔄 Fetching vehicle makes from NHTSA API...');
      
      const response = await fetch('https://vpic.nhtsa.dot.gov/api/vehicles/getallmakes?format=json', {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      });
      
      console.log('📡 API Response status:', response.status);
      
      if (!response.ok) {
        throw new Error(`Error fetching makes: ${response.status} ${response.statusText}`);
      }
      
      const data = await response.json();
      console.log('📊 API Response received, processing data...');
      
      if (data.Results && Array.isArray(data.Results)) {
        console.log('✅ Found', data.Results.length, 'makes from NHTSA API');
        
        // Filtrar y ordenar las marcas más comunes primero
        const commonMakes = [
          'TOYOTA', 'HONDA', 'FORD', 'CHEVROLET', 'NISSAN', 'BMW', 'MERCEDES-BENZ',
          'AUDI', 'VOLKSWAGEN', 'HYUNDAI', 'KIA', 'MAZDA', 'SUBARU', 'LEXUS',
          'ACURA', 'INFINITI', 'CADILLAC', 'LINCOLN', 'BUICK', 'CHRYSLER',
          'DODGE', 'JEEP', 'RAM', 'GMC', 'VOLVO', 'SAAB', 'MITSUBISHI',
          'SUZUKI', 'ISUZU', 'GENESIS', 'TESLA', 'RIVIAN', 'LUCID',
          'FERRARI', 'LAMBORGHINI', 'MASERATI', 'BENTLEY', 'ROLLS-ROYCE',
          'ASTON MARTIN', 'JAGUAR', 'LAND ROVER', 'MINI', 'SMART',
          'ALFA ROMEO', 'FIAT', 'PORSCHE', 'MCLAREN', 'BUGATTI'
        ];
        
        // Obtener las marcas comunes primero
        const commonMakesData = commonMakes.map(makeName => 
          data.Results.find(make => make.Make_Name === makeName)
        ).filter(Boolean);
        
        // Obtener el resto de marcas, excluyendo las comunes
        const otherMakes = data.Results
          .filter(make => !commonMakes.includes(make.Make_Name))
          .sort((a, b) => a.Make_Name.localeCompare(b.Make_Name));
        
        // Combinar: comunes primero, luego el resto
        const allMakes = [...commonMakesData, ...otherMakes];
        
        console.log('🎯 Processed makes:', allMakes.length, 'total (', commonMakesData.length, 'common +', otherMakes.length, 'others)');
        setMakes(allMakes);
        
      } else {
        console.error('❌ Invalid data format from API:', data);
        throw new Error('Invalid data format received from NHTSA API');
      }
      
    } catch (err) {
      console.error('❌ Error fetching vehicle makes from API:', err);
      setError(err.message);
      
      // Usar lista de fallback si la API falla
      console.log('🔄 Using fallback makes list due to API error');
      setMakes(fallbackMakes);
      
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMakes();
  }, []);

  return {
    makes,
    loading,
    error,
    refetch: fetchMakes
  };
};
